import { AlertsSmallFill } from '@elliemae/ds-icons';
import React, { useContext } from 'react';
import { ControlledDateTimePickerDatatestid } from '../../../constants/index.js';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';
import { TimeWheelFooterMessage } from './Styleds.js';

export const TimeWheelFooter: React.ComponentType = () => {
  const {
    props: { pickerFooterMsg, hasError, readOnly, applyAriaDisabled },
    getProps,
    isWithCalendarToo,
  } = useContext(ControlledDateTimePickerContext);
  if (!isWithCalendarToo && pickerFooterMsg !== undefined && hasError)
    return (
      <TimeWheelFooterMessage
        role="alert"
        data-testid={ControlledDateTimePickerDatatestid.FOOTERS.TIMEWHEEL}
        getOwnerProps={getProps}
        $readOnlyStyles={readOnly || applyAriaDisabled}
      >
        <AlertsSmallFill
          width={8}
          height={8}
          color={['danger', '900']}
          style={{ marginRight: '0.5rem', marginBottom: '2px' }}
        />
        {pickerFooterMsg}
      </TimeWheelFooterMessage>
    );
  return null;
};
